/* ===== THIS FILE IS AUTOMATICALLY GENERATED BY GRUNT =====
Blocks registered: header-poly, menu-awesome
*/

import '../../blocks/header-poly/header-poly.js';
import '../../blocks/menu-awesome/menu-awesome.js';